import React from 'react'

const DomesticContext = React.createContext({ 
    step5: { } 
})

export const DomesticProvider = DomesticContext.Provider
export const DomesticConsumer = DomesticContext.Consumer
export default DomesticContext